import { Types } from "../types";
export var elementSectionFragmentSchema = Types.enum(["body", "float", "footer", "header", "navigation", "sidebar", "sticky"]);
//# sourceMappingURL=elementSectionFragment.js.map